<template>
  <v-layout class="grey lighten-4" column>
    <div class="noto bold pa-3 d-md-flex align-center" width="100%">
      <div class="title primary--text">{{ section }}</div>
    </div>

    <v-flex xs12>
      <v-row justify="center">
        <v-col md="12">
          <v-row>
            <v-col cols="12" v-if="bankPermissions['change-provider-bank-information']">
              <v-card flat tile>
                <v-card-title>
                  <v-row>
                    <v-col>
                      {{ section }}
                    </v-col>
                    <v-col class="d-flex justify-end">
                      <v-btn
                        rounded
                        small
                        depressed
                        color="primary"
                        :disabled="!form.isValid || hasExtendLayout"
                        @click="submit">
                        Guardar datos bancarios
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-card-text>
                  <v-alert
                    dense
                    outlined
                    type="info"
                  >
                    Los datos bancarios que ingreses serán los que utilizaremos para hacerte llegar el pago de la compra a través de nuestra plataforma.<br>

                    Estos datos están protegidos por lo tanto <strong> no compartiremos estos datos bajo ninguna circunstancia </strong>.
                  </v-alert>
                  <v-form ref="form" v-model="form.isValid">
                    <v-row>
                      <v-col cols="12">
                        <v-select
                          dense
                          rounded
                          outlined
                          :items="banks"
                          item-text="name"
                          item-value="name"
                          :rules="rules.name"
                          label="Banco"
                          @change="selectBank"
                          v-model="form.bankAccount.name"
                          :disabled="hasExtendLayout">
                          <template v-slot:item="{ item }">
                            {{ item.name }}
                          </template>
                        </v-select>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          dense
                          rounded
                          outlined
                          maxlength="10"
                          :rules="rules.bankAccount"
                          label="Número de cuenta"
                          v-model="maskedNumber"
                          :disabled="hasExtendLayout"/>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          maxlength="18"
                          dense
                          rounded
                          outlined
                          :rules="rules.clabe"
                          label="CLABE"
                          v-model="maskedClabe"
                          :disabled="hasExtendLayout"/>
                      </v-col>
                    </v-row>
                  </v-form>

                  <div class="d-flex justify-end">
                    <v-btn
                      v-if="hasExtendLayout"
                      rounded
                      small
                      depressed
                      color="primary"
                      class="mb-2"
                      @click="openDialog">
                        Solicitar cambios de datos bancarios
                    </v-btn>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col md="12">
          <v-row>
            <v-col cols="12" v-if="bankPermissions['change-provider-bank-information']">
              <v-card flat tile>
                <v-card-title>
                  <v-row>
                    <v-col>
                      Referencias
                    </v-col>
                    <v-col class="d-flex justify-end">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn icon @click="onOpenCreateReference" v-on="on">
                            <v-icon color="blue">mdi-plus-circle</v-icon>
                          </v-btn>
                          </template>
                        <span>Agregar referencia</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-card-text>
                  <v-data-table
                  loading-text="Cargando referencias"
                  :server-items-length="table.total"
                  :loading="table.loading"
                  :headers="table.headers"
                  :items="table.data"
                  :items-per-page="table.limit"
                  :page="table.page"
                  class="elevation-1">
                  <template slot="item.action" slot-scope="{ item }">
                    <v-icon small class="mr-2" @click="onOpenUpdateDialog(item)">mdi-border-color</v-icon>
                    <v-icon small color="error" @click="onOpenRemoveDialog(item)">mdi-delete</v-icon>
                  </template>
                </v-data-table>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-flex>

    <ProviderReferences  :data="data" ref="referenceDialog" @refresh="loadReferences"/>
    <DeleteProviderReferences :data="data" ref="deleteDialog" @refresh="loadReferences"/>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

  </v-layout>
</template>

<script>

import { cloneDeep } from 'lodash'

export default {
  name: 'Providers',
  components: {
    ProviderReferences: () => import('@/components/modals/ProviderReferences'),
    DeleteProviderReferences: () => import('@/components/modals/DeleteProviderReferences')
  },
  data () {
    return {
      section: 'Datos bancarios',
      dialog: false,
      overlay: false,
      disabled: true,
      form: {
        isValid: false,
        bankAccount: {
          name: '',
          number: '',
          clabe: ''
        }
      },
      banks: [
        { name: 'hsbc' },
        { name: 'banamex' },
        { name: 'bancomer' },
        { name: 'santander' },
        { name: 'inbursa' },
        { name: 'banorte' },
        { name: 'azteca' },
        { name: 'scotiabank' },
        { name: 'banregio' },
        { name: 'ixe' },
        { name: 'jpmorgan' },
        { name: 'afirme' },
        { name: 'multiva' },
        { name: 'inmobiliario' },
        { name: 'bancopel' },
        { name: 'banbajio' },
        { name: 'ci' },
        { name: 'mifel' },
        { name: 'citibank' },
        { name: 'stp' },
        { name: 'mercado pago' },
        { name: 'bank of america' },
        { name: 'kapital bank' },
        { name: 'monex' }
      ],
      table: {
        title: this.$i18n.t('sections.title'),
        loading: true,
        data: [],
        headers: [
          { text: 'Restaurante', value: 'restaurant' },
          { text: 'Referencia', value: 'reference' },
          { text: 'Clabe o Cuenta Bancaria', value: 'clabe' },
          { text: 'Acciones', value: 'action', sortable: false }
        ],
        limit: 15,
        total: 0,
        page: 1
      },
      rules: {
        name: [v => !!v || 'El banco es requerido'],
        bankAccount: [
          v => !!v || 'El número de cuenta es requerido',
          // v => /^\d+$/.test(v) || 'Sólo se aceptan números',
          v => (v && v.length === 10) || 'La cuenta debe de contar con 10 carácteres'
        ],
        clabe: [
          v => !!v || 'La clabe interbancaria es requerida',
          // v => /^\d+$/.test(v) || 'Sólo se aceptan números',
          v => (v && v.length === 18) || 'La clabe interbancaria debe de ser de 18 carácteres'
        ]
      },
      data: {}
    }
  },
  computed: {
    provider () {
      return this.$store.state.currentProvider.data._id
    },
    bankPermissions () {
      return this.$store.state.login.permissions['settings'].components['bank-information'].actions
    },
    hasExtendLayout () {
      return this.$store.state.currentProvider.data.extendLayout
    },
    maskedNumber: {
      get () { return this.form.bankAccount.number ? this.form.bankAccount.number.slice(-4).padStart(this.form.bankAccount.number.length, '*') : '' },
      set (value) { this.form.bankAccount.number = value }
    },
    maskedClabe: {
      get () { return this.form.bankAccount.clabe ? this.form.bankAccount.clabe.slice(-4).padStart(this.form.bankAccount.clabe.length, '*') : '' },
      set (value) { this.form.bankAccount.clabe = value }
    }
  },
  async mounted () {
    await this.get()
    await this.loadReferences()
  },
  methods: {
    onOpenUpdateDialog (reference) {
      this.data = cloneDeep(reference)
      this.$refs.referenceDialog.open()
    },
    onOpenCreateReference () {
      this.data = {}
      this.$refs.referenceDialog.open()
    },
    async onOpenRemoveDialog (section) {
      this.data = cloneDeep(section)
      this.$refs.deleteDialog.open()
    },
    async loadReferences (params = null) {
      params = params || {
        limit: this.table.limit,
        skip: (this.table.limit * (this.table.page - 1))
      }
      this.table.loading = true
      try {
        const response = await this.$api.get(`/v1/providers/${this.provider}/references`)
        this.table.data = response
        this.table.total = response.length
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3500, type: 'error', position: 'top-center', iconPack: 'mdi', icon: 'mdi-cancel' })
      }
      this.table.loading = false
    },
    selectBank () {
      if (this.form.bankAccount.name === 'hsbc') {
        this.form.bankAccount.clabe = '000000000000000000'
      } else {
        this.form.bankAccount.number = ''
      }
    },
    async cancel () {
      await this.get()
      this.disabled = true
    },
    async submit () {
      this.overlay = true
      if (!/^\d+$/.test(this.form.bankAccount.number) || !/^\d+$/.test(this.form.bankAccount.clabe)) {
        this.$toasted.show('Sólo se aceptan números en los campos de NÚMERO DE CUENTA o CLABE', { duration: 3000 })
      } else if (this.$refs.form.validate()) {
        try {
          const form = new FormData()
          form.append('bankAccount', JSON.stringify(this.form.bankAccount))
          if (!this.form._id) {
            await this.$api.post(`/v1/providers/${this.provider}/settings`, form)
          } else {
            await this.$api.put(`/v1/providers/${this.provider}/settings`, form)
          }
          this.$toasted.show('Los datos se guardaron con éxito', { duration: 3000 })
          await this.cancel()
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
      }
      this.overlay = false
    },
    async get () {
      this.overlay = true
      try {
        const response = await this.$api.get(`/v1/providers/${this.provider}/settings`)
        if (response) {
          if (response.taxInformation) {
            this.form = response.taxInformation
          }
          this.form.bankAccount = response.bankAccount

          this.phoneList = response.phoneList
        }
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    openDialog () {
      this.dialog = true
    },
    closeDialog () {
      this.dialog = false
    },
    async generateSupportTicket () {
      try {
        const body = {
          issueType: '10006',
          summary: `Solicitud de cambio de datos bancarios de Proveedor: ${this.$store.state.currentProvider.data.name}`,
          description: `El usuario ${this.$store.state.login.user.email}, ha hecho una solicitud de cambio de datos bancarios para el proveedor ${this.$store.state.currentProvider.data.name}`
        }

        await this.$api.post('/v1/jira/create-issue', body)
        this.closeDialog()
        this.$toasted.show('Se creó el ticket correctamente, nos comunicaremos lo más pronto posible', { duration: 5000, type: 'success', position: 'top-center', iconPack: 'mdi', icon: 'mdi-check-circle' })
      } catch (error) {
        this.$toasted.show('Error al crear el ticket', { duration: 3000, type: 'error' })
      }
    }
  }
}
</script>
